export default "__VITE_ASSET__CyzXvr$$__"